class PrivacyAccordion {

    constructor() {
        this.cacheDom();
        this.bindEvents();
    }

    cacheDom() {
        this.accordionBtn = document.querySelectorAll('.c-accordion__header');
    }

    bindEvents() {
        if (_.isNull(this.accordionBtn) === false) {
            Array.prototype.forEach.call(this.accordionBtn, (el, i) => {
                el.addEventListener('click', () => {
                    el.parentNode.classList.toggle('c-accordion--open');
                });
            });
        }
    }
}

module.exports = PrivacyAccordion;